import { CrudModule } from "@/command/ccCrud";

export default function Technology() {
  return (
    <CrudModule
      title="Technology" subtitle="Services and integrations registry with uptime — live."
      module="technology" endpoint="/cc/technology/services" entity="tech_service" summaryPath="/cc/technology/summary"
      columns={[["name", "Service"], ["category", "Category"], ["status", "Status", "badge"], ["uptime_pct", "Uptime", "pct"], ["owner", "Owner"]]}
      fields={[["name", "Service", "text"], ["category", "Category", "select", ["Core", "Data", "AI", "Infra", "Integration"]],
        ["status", "Status", "select", ["Operational", "Degraded", "Down"]], ["uptime_pct", "Uptime %", "number"], ["owner", "Owner", "text"], ["url", "URL", "text"]]}
      defaults={{ status: "Operational", category: "Core" }}
      kpis={(rows, s) => [
        { label: "Services", value: s?.total ?? rows.length },
        { label: "Operational", value: s?.operational ?? 0 },
        { label: "Degraded", value: s?.degraded ?? 0 },
        { label: "Down", value: s?.down ?? 0 },
      ]}
    />
  );
}
